export const MODULE_NAME = {
  HOME: "home",
  WORKBENCH: "Workbench",
  INTELIEDOCS: "Workbench.IntElieDocs",
  ORCHESTRATOR: "Workbench.Orchestrator",
  SMART_EXTRACT_BUILDER: "Workbench.Orchestrator.ExtractBuilder",
  SMART_EXTRACT_MAPPER: "Workbench.Orchestrator.ExtractionModel",
  SMART_CLASSES: "Workbench.Orchestrator.SmartClasses",
  SMART_QUEUE: "Workbench.Orchestrator.SmartQueue",
  ACCESS: "Access",
  UM: "Access.UM",
  ORGANISATION: "Access.Organisation",
  API_KEY: "Access.APIKey",
  BILLING: "Billing",
  DASHBOARD: "Billing.Dashboard",
  HISTORY: "Billing.History",
  SUBSCRIPTION_MANAGER: "Billing.SubscriptionManager",
  BRANDING: "Branding",
  USER_MANUAL: "UserManual",
  DOCUMENTATION: "Documentation",
  INTELIDOCS_MANUAL: "Intelidocs_manual",
  INTELIECONNECT_MANUAL: "Intelieconnect_manual",
  COST_ESTIMATOR: "CostEstimator",
  ORCHESTRATOR_SERVER: "Workbench.Orchestrator.Server",
  IMPORT_CONNECTOR: "IntElieConnect.Import",
  EXPORT_CONNECTOR: "IntElieConnect.Export",
  ELIE_CONNECT: "IntElieConnect",
};
